
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'HeaderLogo',
  methods: {
    startPage() {
      this.$router.push('/')
    },
  },
  computed: {
    mainClasses() {
      let classes = ['header__logo']

      if (this.$route.name !== 'game') {
        classes.push('header__logo-no-game')
      }

      return classes
    },
  },
})
